<template >
    <div class="p-3">
        <div class="d-flex align-items-center mb-4">
            <b-button variant="light" @click="goback()" class="mr-3 rounded-circle shadow-sm">
                <b-icon icon="arrow-left"></b-icon>
            </b-button>
            <h4 class="mb-0 font-weight-bold text-dark">{{ $route.query.desc }}</h4>
        </div>
        <b-card class="mb-4 shadow-sm" header="ບັນຊີໃຫຍ່ແຍກປະເພດ">
            <b-form @submit.prevent="onPreview">
            <b-row md="6" >
                <b-col  >
                    <b-form-group  label="ແຕ່ວັນທີ:" label-cols="4">
                        <b-form-datepicker v-model="fld.from_date" locale="lao"></b-form-datepicker>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col  >
                    <b-form-group label="ເຖິງວັນທີ:" label-cols="4">
                        <b-form-datepicker v-model="fld.to_date" locale="lao"></b-form-datepicker>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-form-group label="ເລກບັນຊີ" label-cols="4">
                         <b-form-input v-model="fld.account_code"  ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>



            
              <b-button block  type="submit" variant="outline-primary"> {{$t('button.preview')}} </b-button>
        

        </b-form>
        </b-card>
        
        {{fld}}

    </div>
</template>
<script>
import axios from "axios";
export default {

    data() {
        return {
              user:[],
            fld:{
                branch_id:"",
                from_date:"",
                to_date:"",
                reportname: this.$route.params.rptname,
                account_code:"",
                script:`call sp_account_hist('111','2017-01-01','2017-12-31','66100000.00')`

            },
            provices: [],
            borders: [],
            params:{
                branch_id:"",
                script:`call sp_account_hist('111','2017-01-01','2017-12-31','66100000.00')`
            }
        }
    },
    created() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);
        this.fld.branch_id=this.user.branch_id

        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/provinces/province_lao/prov_id"
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.provices = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });

    },
    methods: {
        goback() {
            this.$router.go(-1)
        },

        // getBorders() {
        //     //getItemsCondition
        //     axios
        //         .get(
        //             this.$store.getters.getBaseUrl +
        //             "/getItemsCondition/borders/border_name_lao/border_id/prov_id/" + this.fld.prov_id
        //         )
        //         .then((response) => {
        //             // JSON responses are automatically parsed.
        //             this.borders = response.data;
        //             //    console.log(  JSON.parse(response.data))
        //         })
        //         .catch((e) => {
        //             console.log(e);
        //         });
        // },

        onPreview(){
            this.fld.script=`call sp_account_hist('`+this.fld.branch_id+`','`+this.fld.from_date+`','`+this.fld.to_date+`','`+this.fld.account_code+`')`
            let data = JSON.stringify(this.fld);
             this.$router.push('/view/rpt_sp_account_hist.mrt?data='+data)
        }
    },
}
</script>
<style  scoped >
.content {
    margin-top: 20px;
}

.notolao {
    font-family: 'Noto Sans Lao Regular', 'Phetsarath OT';
}
</style>